import "../../../styles/news.css";
import SubTitle from "../others/title/SubTitle";
import { useGetAllPostsCard } from "../../../hooks/usePosts";
import Loading from "../others/Loading";
import { imagemURL } from "../../../services/variables";

export default function News() {
  const { data, isError, isLoading } = useGetAllPostsCard();

  if (isLoading) return <Loading />;
  if (isError) return <p>Nenhuma noticia encontrada.</p>;

  return (
    <div>
      <div className="section-title rotes_pages">
        <h6> Início / Notícias</h6>
      </div>
      <SubTitle subTitle={"Notícias"} border={true} />
      <div className="box_news">
        {data.map((news) => (
          <a
            href={`/noticia/${news.slug}`}
            target="_self"
            rel="noopener noreferrer"
            className="news_item"
            key={news.id}
          >
            {news.featuredImage?.node?.sourceUrl && !news.oldImage ? (
              <img
                width={320}
                height={250}
                alt={news.featuredImage.node.altText || news.title}
                src={news.featuredImage.node.sourceUrl}
                className="news_img"
                loading="lazy"
              />
            ) : (
              <img
                width={320}
                height={250}
                alt={news.title}
                src={imagemURL + news.oldImage}
                className="news_img"
                loading="lazy"
              />
            )}

            <div className="news_content">
              <p className="news_title">{news.title}</p>

              <p className="news_date">
                Publicado em:{" "}
                {new Date(news.date).toLocaleDateString("pt-BR", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>

              <div className="cat_views">
                <p className="news_category">
                  {news.categories?.nodes?.[0]?.name || "Sem categoria"}
                </p>

                <p className="news_views">
                  {news.views}
                  <img
                    width={30}
                    height={30}
                    alt="views"
                    src="/icons/views.svg"
                    className="icon-views"
                  />
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
